import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { API_BASE } from './utils/api-base';
import './styles/globals.css';
import './utils/chart-defaults';

const nativeFetch = window.fetch.bind(window);
window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
  if (typeof input === 'string') {
    const isRelativeApiPath = input.startsWith('/api') || input.startsWith('/auth');
    if (isRelativeApiPath) {
      return nativeFetch(`${API_BASE}${input}`, init);
    }
  }
  return nativeFetch(input, init);
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
